import React, { useState } from 'react';

import FileViewModal from '@features/assets/components/CommonComponents/FileViewModal';

const ArtworkItem = ({ artwork, onEdit, onDeleteClick }) => {
	const [selectedArtworkId, setSelectedArtworkId] = useState(null);

	const renderColors = (allColors) => {
		return allColors?.map((item, idx) => (
			<span className="color-icon" key={`artwork_${idx}`} style={{ background: `${item?.hexCode}` }} />
		));
	};
	return (
		<div className="single-design-card with-editable">
			<div className="card-top">
				<div className="edit-items">
					<div className="select-and-edit d-flex justify-content-between">
						<div></div>
						<div className="option">
							<div className="dropdown">
								<button
									className="btn btn-default dropdown-toggle"
									type="button"
									id="menu1"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<img src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`} alt />
								</button>
								<ul
									className="dropdown-menu dropdown-menu-right shadow-lg"
									role="menu"
									aria-labelledby="menu1"
									x-placement="bottom-end"
								>
									<li>
										<span onClick={() => onEdit(artwork?.id)}>Edit</span>
									</li>
									<li>
										<span
											className="red"
											onClick={() => {
												onDeleteClick(artwork?.id);
											}}
										>
											Delete
										</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<img
					src={
						artwork?.documentResponseList?.length > 0 &&
						artwork.documentResponseList.find((doc) => doc.docType === 'ASSETS_IMAGE_S1')?.docUrl
							? artwork.documentResponseList.find((doc) => doc.docType === 'ASSETS_IMAGE_S1')
									?.docUrl
							: `${process.env.PUBLIC_URL}/images/sketch-dress.png`
					}
					alt="card-image"
					onClick={() => setSelectedArtworkId(artwork?.id)}
				/>
			</div>
			<div className="card-content" onClick={() => setSelectedArtworkId(artwork?.id)}>
				<h3 className="semibold-12 weight-600 design-title gray_dark_01">
					{artwork?.referenceNumber}
				</h3>
				<div className="card-info d-flex justify-content-between">
					<ul className="list-item-with-dot">
						{artwork?.moodTagResponse?.text && (
							<li className="regular-1 gray_dark_02">{artwork?.moodTagResponse?.text}</li>
						)}
						{artwork?.artworkPatternTagResponse?.text && (
							<li className="regular-12 gray_dark_02">
								{artwork?.artworkPatternTagResponse?.text}
							</li>
						)}
						{artwork?.inspiredFrom && (
							<li className="regular-12 gray_dark_02">{artwork?.inspiredFrom}</li>
						)}
					</ul>
				</div>
				<div className="color-code d-flex gap-2 flex-wrap mt-1">
					{renderColors(artwork?.colorResponseList)}
				</div>
			</div>
			{selectedArtworkId && (
				<FileViewModal
					viewType={'ARTWORK'}
					selectedItemId={selectedArtworkId}
					onClose={() => setSelectedArtworkId(null)}
				/>
			)}
		</div>
	);
};

export default ArtworkItem;
